import React from "react"
import "./MapInfo.css"
import { t } from "i18next"
import refresh from "./assets/refresh.svg"

function MapInfo({
  onRefresh,
  len_collars,
  loading,
  isStaff,
}: {
  onRefresh: () => void
  len_collars: number
  loading?: boolean
  isStaff?: boolean
}) {
  return (
    <div className="MapInfoContainer">
      {!isStaff && len_collars < 1000 && (
        <div className="MapInfoTextBackground">
          <p className="MapInfoText">{t("mapInfo")}</p>
        </div>
      )}
      <button onClick={(e) => onRefresh()} className="RefreshButton" disabled={loading}>
        {loading ? (
          <span className="Spinner" aria-label="Loading" />
        ) : (
          <img src={refresh} alt="refresh" width={24} height={24} />
        )}
      </button>
    </div>
  )
}

export default MapInfo
